// eslint-disable-next-line restrict-imports/restrict-imports
import database from '../../foreground/database';
import { isDocumentShareApp, isTest } from '../../utils/environment';

/*
  Our Cypress component tests were throwing "Cannot access 'database' before initialization" for some reason. This works around that.
*/
export default isTest || isDocumentShareApp
  ? new Proxy(
      {},
    {
      get(target, property) {
        // Explanation: Proxy get trap — property is inherently dynamic, no static type available
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-type-assertion
        return (database as any)[property];
      },
    },
    )
  : database;
